import React from "react"
import styled, {css} from "styled-components"
import {DESKTOP} from "@irati/ui/src/global/media"
import {useStoreContext} from "../../context/StoreContext"
import {useStoreBannersQuery} from "@irati/payrollpay/hooks"
import {PayrollPayBanner} from "@irati/types"
import Slider from "@irati/ui/src/Slider"
import Loading from "@irati/ui/src/Loading"

interface StoreBannersData {
  employeeOrganisation?: {
    scheme?: {
      banners?: PayrollPayBanner[]
    }
  }
}

export const BannerSection = () => {
  const {schemeType} = useStoreContext()
  const scheme = {schemeType}

  const {data, load} = useStoreBannersQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const banners = (data as StoreBannersData)?.employeeOrganisation?.scheme?.banners as PayrollPayBanner[]

  return (
    <Loading load={load}>
      <BannerSlider>
        <Slider
          slidesToShow={1}
          settings={{
            dots: false,
            infinite: true,
            speed: 500,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            responsive: [
              {
                breakpoint: DESKTOP,
                settings: {
                  dots: true,
                  arrows: false
                }
              }
            ]
          }}>
          {banners?.map((banner, index) => (
            <BannerSlide key={index}>
              <BannerImage src={banner.mobileImageUrl} desktopSrc={banner.desktopImageUrl} alt={banner.title || `Banner ${index}`} />
            </BannerSlide>
          ))}
        </Slider>
      </BannerSlider>
    </Loading>
  )
}

const BannerSlider = styled.div`
  max-width: 100vw;
  margin: ${({theme}) => theme.spacing.three} auto;
  width: 100%;
`

const BannerSlide = styled.div`
  width: 100%;
  height: 100%;
`

interface BannerImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  desktopSrc?: string
}

const BannerImage = styled.img<BannerImageProps>`
  ${({theme, desktopSrc}) => css`
    width: 100%;
    height: 133px;
    object-fit: cover;
    border-radius: ${theme.border.radius.large};

    ${desktopSrc &&
    theme.mediaQueries.minWidthMedia.desktop`
        content: url(${desktopSrc});
      `}
  `}
`
